import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '../../../context/AppContext';
import { useSimulado } from '../../../context/SimuladoContext';

function RankingContent() {
  const { user } = useApp();
  const { simulado } = useSimulado();
  const [rankingData, setRankingData] = useState([]);
  const [groupRankingData, setGroupRankingData] = useState([]);
  const [userRankingData, setUserRankingData] = useState(null);
  const [simuladoDate, setSimuladoDate] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const userID = user?.ID_usuario;
  const selectedSimuladoID = simulado.id;

  const roundToOneDecimal = (number) => {
    if (number === null || number === undefined || number === 0) return '-';
    return Number(number).toFixed(1);
  };

  const getPositionClass = (position) => {
    if (!position || isNaN(position)) return '';
    const pos = parseInt(position);
    if (pos >= 1 && pos <= 5) return `position-${pos}`;
    return '';
  };

  useEffect(() => {
    if (!userID || !selectedSimuladoID) return;

    const fetchRankingData = async () => {
      try {
        const response = await fetch(`https://rveducacao.com.br/get.php?action=ranking&user_id=${userID}&exam_id=${selectedSimuladoID}`);
        const data = await response.json();

        setRankingData(data.overall_ranking ? JSON.parse(data.overall_ranking).slice(0, 10) : []); // só exibe os primeiros 10 colocados
        setGroupRankingData(data.group_ranking ? JSON.parse(data.group_ranking).slice(0, 10) : []); 
        setSimuladoDate(data.exam_date || localStorage.getItem('simuladoDate') || '');
        setUserRankingData(data);
      } catch (err) {
        setError(err.message);
        console.error('Erro ao buscar ranking:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchRankingData();
  }, [userID, selectedSimuladoID]);

  if (loading) {
    return <div className='empty'>Seus dados de ranking aparecerão aqui</div>;
  }

  if (error || !rankingData) {
    return <div className='empty'>Seus dados de ranking aparecerão aqui</div>;
  }

  return (
    <div className="ranking-container">

      <div className='ranking-info'>
        <div className='exam dashboard-link ranking'>
          <Link to="/historico" className="no-link-style"> Simulado realizado em {simuladoDate} </Link>
        </div>
      </div>

      <div className='ranking-details-container'>
        <div className="ranking">

          <div className='ranking-geral'>
            <h3 className='ranking-page-title'>Ranking geral</h3>

            <div className="ranking-table">
              <table>
                <thead>
                  <tr>
                    <th className="ranking-header"></th>
                    <th className="ranking-header">CN</th>
                    <th className="ranking-header"></th>
                    <th className="ranking-header">MT</th>
                    <th className="ranking-header"></th>
                    <th className="ranking-header geral">GERAL</th>
                  </tr>
                </thead>
                <tbody>
                  {rankingData.map((data, index) => {
                    const nameParts = data.nome.split(" ");
                    const formattedName =
                      nameParts.length > 1
                        ? `${nameParts[0]} ${nameParts[nameParts.length - 1]}`
                        : data.nome;

                    return (
                      <tr key={index} className="ranking-details">
                        <td className="rank-content">
                          <div className="ranking-name">
                            <div className={`posicao-circle ${getPositionClass(data.posicao_geral)}`}>
                              <p>{data.posicao_geral ? `${data.posicao_geral}º` : '-'}</p>
                            </div>
                            <span className="nome">{formattedName}</span>
                          </div>
                        </td>
                        <td className='position'>{data.posicao_natureza}º </td>
                        <td className='grade'>| {roundToOneDecimal(data.nota_natureza)}</td>
                        <td className='position'>{data.posicao_matematica}º</td>
                        <td className='grade'>| {roundToOneDecimal(data.nota_matematica)}</td>
                        <td>{roundToOneDecimal(data.nota_geral_sem_redacao)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>

          <div className="divide-line"></div>

          {userRankingData && (
            <div className="ranking-details">
              <div className="ranking-line">
                <div className="ranking-entry">
                  <div className={`posicao-circle ${getPositionClass(userRankingData.overall_position)}`}>
                    <p>{userRankingData.overall_position ? `${userRankingData.overall_position}º` : '-'}</p>
                  </div>
                  <div className="rank-content">
                    <div className="rank-values">
                      <p className="nome">{userRankingData.name}</p>
                      <p>
                        {userRankingData.CN_position}º | {roundToOneDecimal(userRankingData.CN_grade)}
                      </p>
                      <p>
                        {userRankingData.MT_position}º | {roundToOneDecimal(userRankingData.MT_grade)}
                      </p>
                      <p>{roundToOneDecimal(userRankingData.overall_grade)}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

        </div>

        <div className='ranking-data-container'>

          <div className="ranking-data group">
            <h3 className='ranking-page-title grupo'>Ranking por grupo</h3>
            <div className="ranking-table details">
              <table>
                <thead>
                  <tr>
                    <th className="ranking-header"></th>
                    <th className="ranking-header">CN</th>
                    <th className="ranking-header"></th>
                    <th className="ranking-header">MT</th>
                    <th className="ranking-header"></th>
                    <th className="ranking-header geral">GERAL</th>
                  </tr>
                </thead>
                <tbody>
                  {groupRankingData.map((data, index) => {
                    const nameParts = data.nome.split(" ");
                    const formattedName =
                      nameParts.length > 1
                        ? `${nameParts[0]} ${nameParts[nameParts.length - 1]}`
                        : data.nome;

                    return (
                      <tr key={index} className="ranking-details">
                        <td className="rank-content">
                          <div className="ranking-name">
                            <div className={`posicao-circle ${getPositionClass(data.posicao_grupo)}`}>
                              <p>{data.posicao_grupo ? `${data.posicao_grupo}º` : '-'}</p>
                            </div>
                            <span className="nome">{formattedName}</span>
                          </div>
                        </td>
                        <td className='position'>{data.posicao_natureza}º </td>
                        <td className='grade'>| {roundToOneDecimal(data.nota_natureza)}</td>
                        <td className='position'>{data.posicao_matematica}º</td>
                        <td className='grade'>| {roundToOneDecimal(data.nota_matematica)}</td>
                        <td>{roundToOneDecimal(data.nota_geral_sem_redacao)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <div className="divide-line"></div>

            {userRankingData && (
              <div className="ranking-details group">
                <div className="ranking-line">
                  <div className="ranking-entry">
                    <div className={`posicao-circle ${getPositionClass(userRankingData.group_position)}`}>
                      <p>{userRankingData.group_position ? `${userRankingData.group_position}º` : '-'}</p>
                    </div>
                    <div className="rank-content">
                      <div className="rank-values">
                        <p className="nome">{userRankingData.name}</p>
                        <p>
                          {userRankingData.CN_position}º | {roundToOneDecimal(userRankingData.CN_grade)}
                        </p>
                        <p>
                          {userRankingData.MT_position}º | {roundToOneDecimal(userRankingData.MT_grade)}
                        </p>
                        <p>{roundToOneDecimal(userRankingData.overall_grade)}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

          </div>

          <div className="ranking-data media">
            <h3 className='ranking-page-title media'>Sua média</h3>
            <div className='info'>
              <p className='info-card-note'> {roundToOneDecimal(userRankingData?.overall_grade)} </p>
              <p className='info-card-text'>Média sem redação </p>
            </div>
            <div className='info'>
              <p className='info-card-note'> - </p>
              <p className='info-card-text'>Média com redação </p>
            </div>
          </div>

          <div className="ranking-data media">
            <h3 className='ranking-page-title media'>Média dos candidatos</h3>
            <div className='info'>
              <p className='info-card-note'>{roundToOneDecimal(userRankingData?.exam_mean)}</p>
              <p className='info-card-text'>Média sem redação</p>
            </div>
            <div className='info'>
              <p className='info-card-note'>-</p>
              <p className='info-card-text'>Média com redação</p>
            </div>
          </div>

          <div className="ranking-data media">
            <h3 className='ranking-page-title media'>Média do seu grupo</h3>
            <div className='info'>
              <p className='info-card-note'>{roundToOneDecimal(userRankingData?.exam_group_mean)}</p>
              <p className='info-card-text'>Média sem redação</p>
            </div>
            <div className='info'>
              <p className='info-card-note'>-</p>
              <p className='info-card-text'>Média com redação</p>
            </div>
          </div>

        </div>

      </div>

    </div>
  );
}

export default RankingContent;
